export const columns = [{
    label: 'Agent',
    key: 'AGENT_LAST_NAME',
},{
//     label: 'SUMMIT Start Date',
//     key: 'STRIVE_START_DATE',
//     type: 'date',
//     editable: true,
// }, {
    label: 'Phone Start Date',
    key: 'START_DATE',
    type: 'date',
    editable: true,
}, {
    label: '# of Calls',
    key: 'CALLS',
    type: 'number',
    editable: true,
    hasHighlight: true,
}, {
    label: 'Ave Calls/Week',
    key: 'AVE_CALLS',
    type: 'number',
    hasHighlight: true,
}, {
    label: '# of Meetings',
    key: 'MEETINGS',
    type: 'number',
    editable: true,
}, {
    label: 'Ave Meetings/Week',
    key: 'AVE_MEETINGS',
    type: 'number',
}, {
    label: '# of Proposals',
    key: 'PROPOSALS',
    type: 'number',
    hasHighlight: true,
}, {
    label: 'Ave Proposals/Week',
    key: 'AVE_PROPOSALS',
    type: 'number',
    hasHighlight: true,
}, {
    label: '# of Listings',
    key: 'TOTAL_LISTINGS',
    type: 'number',
}, {
    label: '# Under Contract',
    key: 'TOTAL_UC',
    type: 'number',
    hasHighlight: true,
}, {
    label: '# Closed',
    key: 'TOTAL_CLOSED',
    type: 'number',
}, {
    label: 'Total Gross Fee',
    key: 'TOTAL_GROSS_FEE',
    type: 'number',
},];

export const averageColumns = columns.filter(column => column.key.includes('AVE'));